class SlideshowSlider extends HTMLElement {
  slider: HTMLDivElement | null = null;
  slides: HTMLDivElement | null = null;
  delay: number = 5000;

  constructor() {
    super();
    this.slider = this.querySelector('#announcement-slider');
    this.slides = this.querySelectorAll('[id^="announcement-slide-"]');
    this.delay = this.slider.getAttribute('data-rotate-speed') * 1000;

    if (this.slides.length < 2) return;

    this.autoScroll();
  }

  autoScroll() {
    let i = 1;
    if (i < this.slides.length) {
      setInterval(() => {
        this.next(i);
        i = i + 1;

        if (i === this.slides.length) {
          this.jumpToIndex(0);
          i = 0;
        }
      }, this.delay);
    }
  }

  jumpToIndex = (index) => {
    this.scroll(this.scrollWidth * index, index);
  };

  computeScrollWidth = () => {
    return this.slider.scrollWidth / this.slideCount;
  };

  scroll = (left: number, index) => {
    if (index < this.slideCount) this.slider.scroll({ left, behavior: 'smooth' });
  };

  hideOtherSlides() {
    this.slides?.forEach((slide) => {
      slide.classList.add('translate-y-full');
      slide.classList.remove('translate-y-0');
    });
  }

  next = (index) => {
    this.hideOtherSlides();
    this.slides[index].classList.remove('hidden');
    this.slides[index].classList.add('flex');
    this.slides[index].classList.remove('translate-y-full');
    this.slides[index].classList.add('translate-y-0');
  };
}

if (!customElements.get('slideshow-slider')) {
  window.customElements.define('slideshow-slider', SlideshowSlider);
}
